export const GeneralConstants = {
    GOOGLE_MAP_API_KEY : "AIzaSyBNcHDgzp83ZjeIl86b3RfBsQUd7JZRPDs",
}
export const UserTypes = {
    ADMIN: 2,
    ORG: 3,
}
